module.exports = __webpack_public_path__ + "50cbcfe2837f415b8b78ec399d6f900c.pdf";